import { FORMAT_CAROUSEL, FORMAT_EXISTING_POST, FORMAT_SINGLE, FORMAT_STORY } from '../../../fields'
import { MEDIA_TYPE } from '../../../../../ReusableFormFields/AdFileUpload/fields'

const OPT_OUT = { enroll_status: 'OPT_OUT' }

export const formatDegreesOfFreedomSpec = ({ formatOption, mediaType, carouselItems, storiesItems }) => {
  const defaultFeatures = {
    image_templates: OPT_OUT,
    image_touchups: OPT_OUT,
    text_optimizations: OPT_OUT,
    inline_comment: OPT_OUT
  }

  const hasVideoInItems = items => Array.isArray(items) && items.some(item => item[MEDIA_TYPE] === 'video')

  let creativeFeatures = {}

  switch (formatOption) {
    case FORMAT_SINGLE:
      creativeFeatures =
        mediaType === 'video'
          ? { video_auto_crop: OPT_OUT, text_optimizations: OPT_OUT, inline_comment: OPT_OUT }
          : { ...defaultFeatures }
      break

    case FORMAT_CAROUSEL:
      creativeFeatures = { ...defaultFeatures }
      if (hasVideoInItems(carouselItems)) {
        creativeFeatures.video_auto_crop = OPT_OUT
      }
      break

    case FORMAT_STORY:
      creativeFeatures = { ...defaultFeatures }
      if (hasVideoInItems(storiesItems)) {
        creativeFeatures.video_auto_crop = OPT_OUT
      }
      break

    case FORMAT_EXISTING_POST:
      creativeFeatures = { ...defaultFeatures }
      break

    default:
      return {}
  }

  return {
    creative_features_spec: {
      ...creativeFeatures,
      standard_enhancements: { enroll_status: 'OPT_OUT' }
    }
  }
}
